import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { editProcessLoss, fetchDefinedProcessLoss } from "../../../redux/processLossSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import SuccessModal from "../../../components/Modals/SuccessfulModal";


/* Edit Process Loss Form Validation */
export const EDIT_PROCESS_LOSS_VALIDATION = yup.object().shape({
    spinningProcessLoss: yup.number().required("Spinning % is required."),
    knittingProcessLoss: yup.number().required("Knitting % is required."),
    processingProcessLoss: yup.number().required("Processing % is required."),
    designingProcessLoss: yup.number().required("Designing % is required."),
    flatkinttingProcessLoss: yup.number().required("Flatknitting % is required."),
    yarndyeingProcessLoss: yup.number().required("Yarn Dyeing % is required."),
});

const EditdefinedLoss = () => {

    /********************************* Variable Decleration *********************************/
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /********************************* State Management *********************************/

    const [processLossType, setProcessLossType] = useState("defined");
    const [isEditSuccess, setSucessModalOpenStatus] = useState(false);

    /********************************* Functions  Fetch State Varibles from Store *********************************/

    const viewData = useSelector((state) => state.processLoss?.definedProcessLossInfo || {});
    const { loading } = useSelector((state) => state.processLoss);

    /* Edit Process Loss Form Defulat values */
    const defaultValues = {
        spinningProcessLoss: Math.floor(viewData[0]?.process_loss),
        knittingProcessLoss: Math.floor(viewData[1]?.process_loss),
        processingProcessLoss: Math.floor(viewData[2]?.process_loss),
        designingProcessLoss: Math.floor(viewData[3]?.process_loss),
        flatkinttingProcessLoss: Math.floor(viewData[5]?.process_loss),
        yarndyeingProcessLoss: Math.floor(viewData[6]?.process_loss),
    };
    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
        if (e.code === 'Period') {
            e.preventDefault();
        }
    }

    /********************************* Use Effect *********************************/
    useEffect(() => {
        const queryParams = {
            type: processLossType
        };
        dispatch(fetchDefinedProcessLoss(queryParams));
    }, [dispatch]);

    /********************************* Functions *********************************/

    const handleEditProcessSubmit = (data) => {
        const updateEditProcessLossData = [
            {
                process_loss_id: 1,
                process_loss: data.spinningProcessLoss
            },
            {
                process_loss_id: 2,
                process_loss: data.knittingProcessLoss
            },
            {
                process_loss_id: 3,
                process_loss: data.processingProcessLoss
            },
            {
                process_loss_id: 4,
                process_loss: data.designingProcessLoss
            },
            {
                process_loss_id: 5,
                process_loss: 0
            },
            {
                process_loss_id: 6,
                process_loss: data.flatkinttingProcessLoss
            },
            {
                process_loss_id: 7,
                process_loss: data.yarndyeingProcessLoss
            }
        ]
        dispatch(editProcessLoss(updateEditProcessLossData)).then((response) => {
            if (response.payload.success) 
            { 
                setSucessModalOpenStatus(true);
            };
        });
    };

    /********************************* UI Components *********************************/
    return (
        <div>

            {/* Headings */}
            <div className="d-flex justify-content-between">
                <div>
                    <h1 className="heading1">Edit Process Loss </h1>
                    <h5 className="heading2">Review carefully Process Loss </h5>
                </div>
                <div>
                    <h5 className="navPageIfo">
                        Home / <span style={{ color: " #C8C7C9" }}>Edit Process Loss</span>
                    </h5>
                </div>
            </div>
            {/* Form */}
            <div>
                <div className="card mt-3 bg-stage">
                    <div className="card-body pt-4">
                        <Formik
                            initialValues={defaultValues}
                            enableReinitialize={true}
                            validationSchema={EDIT_PROCESS_LOSS_VALIDATION}
                            onSubmit={(values, { setSubmitting }) => {
                                const formattedValues = {
                                    ...values,
                                };
                                // onSubmit(formattedValues);
                                handleEditProcessSubmit(formattedValues);
                                setSubmitting(false);
                            }}
                        >
                            {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched, }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.spinning")}
                                                className="md-input"
                                                name="spinningProcessLoss"
                                                value={values.spinningProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.spinningProcessLoss}
                                                helperText={errors.spinningProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.knitting")}
                                                className="md-input"
                                                name="knittingProcessLoss"
                                                value={values.knittingProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.knittingProcessLoss}
                                                helperText={errors.knittingProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.processing") + "%"}
                                                className="md-input"
                                                name="processingProcessLoss"
                                                value={values.processingProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.processingProcessLoss}
                                                helperText={errors.processingProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.designing") + "%"}
                                                className="md-input"
                                                name="designingProcessLoss"
                                                value={values.designingProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.designingProcessLoss}
                                                helperText={errors.designingProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.flat-knitting") + "%"}
                                                className="md-input"
                                                name="flatkinttingProcessLoss"
                                                value={values.flatkinttingProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.flatkinttingProcessLoss}
                                                helperText={errors.flatkinttingProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                        <div className="col-md-4 cs-form mb-3">
                                            <TextField
                                                type="number"
                                                label={t("reviewdefineloss.yarn-dyeing") + "%"}
                                                className="md-input"
                                                name="yarndyeingProcessLoss"
                                                value={values.yarndyeingProcessLoss}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.yarndyeingProcessLoss}
                                                helperText={errors.yarndyeingProcessLoss}
                                                InputProps={{
                                                    inputProps: { min: 0, step: 1, max: 100 }
                                                }}
                                                onKeyDown={preventMinus}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="d-flex justify-content-between">
                                            <button type="button" className="btn btn-light grey-btn lg-btn" onClick={() => navigate(-1)}>{t('createOrder.back')}</button>
                                            <button className="btn btn-primary greeen-btn lg-btn" type='submit' variant="contained" onClick={handleSubmit}>
                                                {loading ? 'Submitting...' : t('linkModal.update')}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </Formik>
                        {isEditSuccess &&
                            <SuccessModal
                                isOpen={isEditSuccess}
                                msg={"Process Loss data updated"}
                                navigatePage={'/special-plan'}

                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditdefinedLoss;
